module.exports = __webpack_public_path__ + "assets/Nu.5394ed2de52ef365ebe37e6401c5977c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Nu.png
// module id = 839
// module chunks = 0